import { configureStore } from "@reduxjs/toolkit";
import { tiposDocsSlice } from "./slices/tiposDocumentosSlices.ts";
import { reportantesSlice } from "./slices/reportantesSlices.ts";
import { clinicasSlices } from "./slices/clinicasSlices.ts";



export const store = configureStore({
    reducer: {
        tiposDocs: tiposDocsSlice.reducer,
        reportantes: reportantesSlice.reducer,
        clinicas: clinicasSlices.reducer
    }
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch